import RoomInformation from '../RoomInformation'
import PatientInformation from '../PatientInformation'
import { TCaseInformationProps } from './CaseInformation.types'

const CaseInformation: React.FC<TCaseInformationProps> = (props) => {
  const { surgery, showDate = true, onClick } = props

  return (
    <>
      <RoomInformation
        surgery={surgery}
        showDate={showDate}
        onClick={onClick}
      />
      <PatientInformation surgery={surgery} />
    </>
  )
}

export default CaseInformation
